import { isProcessing, isUploading } from '../utils';

export const useTableRowGeneral = ({ item }) => {
  return {
    isUploading: isUploading(item),
    isProcessing: isProcessing(item),
  };
};
